(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")); /*!
                                                                                                                                                                                                                                                                                                                                                                                                    * 跟随主耶稣的脚踪 v2 全局js
                                                                                                                                                                                                                                                                                                                                                                                                    *
                                                                                                                                                                                                                                                                                                                                                                                                    | 全能神说: "在這最末了的時代最末了的時代,
                                                                                                                                                                                                                                                                                                                                                                                                    |           讓神的名能在外邦中被稱為大,
                                                                                                                                                                                                                                                                                                                                                                                                    |           使神的作為被外邦中的人被外邦中的人看見,
                                                                                                                                                                                                                                                                                                                                                                                                    |           且因神的神的作為而稱神為全能者,
                                                                                                                                                                                                                                                                                                                                                                                                    |           讓神口之言早日得著早日得著成就"
                                                                                                                                                                                                                                                                                                                                                                                                    |
                                                                                                                                                                                                                                                                                                                                                                                                    | Almighty God says:
                                                                                                                                                                                                                                                                                                                                                                                                    |           “In the end times, in the final age,
                                                                                                                                                                                                                                                                                                                                                                                                    |           God’s name will be magnified among Gentile nations.
                                                                                                                                                                                                                                                                                                                                                                                                    |           The acts of God will be by Gentiles seen,
                                                                                                                                                                                                                                                                                                                                                                                                    |           and they’ll address Him as the Almighty,
                                                                                                                                                                                                                                                                                                                                                                                                    |           and thus His words shall one day soon come true”
                                                                                                                                                                                                                                                                                                                                                                                                    |
                                                                                                                                                                                                                                                                                                                                                                                                    * @author : Buff
                                                                                                                                                                                                                                                                                                                                                                                                    * @date : 12/3/2017
                                                                                                                                                                                                                                                                                                                                                                                                    * @Time: 3:45 PM
                                                                                                                                                                                                                                                                                                                                                                                                    * @standards : ECMAScript 5
                                                                                                                                                                                                                                                                                                                                                                                                    */

// - - - - - - - - - - - - - - - - - - - 全局card-panel上滑动画 - - - - - - - - - - - - - - - - - - -
window.V2CardPanelSr = ScrollReveal({
  reset: false,
  origin: 'bottom',
  duration: 1500,
  delay: 0,
  scale: 1,
  easing: 'ease',
  mobile: true,
  distance: '50px' });


// - - - - - - - - - - - - - - - - - - - 全局事件 - - - - - - - - - - - - - - - - - - -
var v2Global = /*#__PURE__*/function () {
  function v2Global() {(0, _classCallCheck2["default"])(this, v2Global);

    //  绑定点赞按钮
    this.likeHandler();

    //  检查页面需要的点赞 监听
    this.pageNeedWatchLike();

    //  处理移动端 惜朝提出的侧边栏点击箭头展开
    this.mobileDropmoreTrigger();

    //  处理组体区域与侧边栏的粘帖效果
    this.stickMainWithAside();

    //  处理页面图片懒加载
    this.lazyLoadImg();

    //  处理youtube 视频时间问题, 通过 videoId 获取duration
    this.getYoutubeDuration();

    //  imgBox hover效果 处理
    this.imgBox();

    //  videoBox hover效果处理
    this.videoBox();

    //  处理tags 标签下没有 a 链接,导致光输出一个tag的问题
    this.clearTags();

  }

  /**
     * 处理页面空tags 问题
     *  div.tags
     *  <i class="icon-priceTag"></i>
     *    without a
     */(0, _createClass2["default"])(v2Global, [{ key: "clearTags", value: function clearTags()
    {
      $('.tags').map(function (i, obj) {
        obj = $(obj);
        if (obj.find('.icon-priceTag').length > 0 && obj.find('a').length == 0) {
          obj.addClass('hidden');
        }
      });
    }

    /**
       * 处理鼠标移入 videoBox(视频图片) 时的动画效果
       * div.videoBox > a > img
       */ }, { key: "videoBox", value: function videoBox()
    {
      $('.videoBox').map(function () {
        $(this).find('a').append($("\n        <div class=\"videoBoxHover\">\n            <i class=\"icon-playCircle\"></i>\n        </div>\n    "));




      });
    }

    /**
       * 处理鼠标移入 imgBox(基本文章图片) 时的动画效果
       * a.imgBox>img
       */ }, { key: "imgBox", value: function imgBox()
    {
      $('.imgBox').not('.videoBox').map(function () {
        $(this).append($("\n        <div class=\"imgBoxHover\">\n            <i class=\"icon-openNew\"></i>\n            <div class=\"imgBoxMark\"></div>\n        </div>\n    "));





      });
    }

    /**
       * 处理youtube 视频时间问题, 通过 videoId 获取duration
       * <span class="duration" data-videoid="Y-BHgxXkkTk"></span>
       */ }, { key: "getYoutubeDuration", value: function getYoutubeDuration()
    {
      var vidStr = [];
      var youtubeApiV3Key = window.v2WebFarm && window.v2WebFarm.youtubeApiV3Key ? window.v2WebFarm.youtubeApiV3Key : 'AIzaSyDhJos-VLqwMl9uOLDuZKHkjvHnVkTiIhI';

      $('span.duration').map(function () {
        var vid = $(this).data('videoid');
        if (vid) {
          vidStr.push(vid);
        }
      });


      //  如果存在视频 video ID 需要获取duration
      if (vidStr.length > 0) {

        //  把数据分组 , 一次发太多, youtube 不处理
        var limit = 45;
        var _arraySplit = [];
        var _index = 0;
        _arraySplit[0] = [];
        vidStr.map(function (value, index) {
          if (index > limit * (_index + 1)) {
            ++_index;
            _arraySplit[_index] = [];
          }

          _arraySplit[_index].push(value);
        });

        //  根据分割好的数据,发送ajax 获取duration
        _arraySplit.map(function (arr) {
          if (arr.length > 0) {
            var sVideosId = arr.join(',');

            //  发送ajax 请求
            $.ajax({
              data: {
                part: 'snippet,contentDetails,statistics',
                id: sVideosId,
                key: youtubeApiV3Key },

              dataType: 'json',
              type: 'GET',
              url: 'https://www.googleapis.com/youtube/v3/videos' }).
            then(function (data) {
              if (data.items.length > 0) {
                data.items.map(function (value) {
                  var duration = value.contentDetails.duration;
                  var vid = value.id;

                  var match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);

                  var hours = parseInt(match[1]) || 0;
                  var minutes = parseInt(match[2]) || 0;
                  var seconds = parseInt(match[3]) || 0;

                  duration = hours * 3600 + minutes * 60 + seconds;

                  var h = String('00' + Math.floor(duration / 3600)).slice(-2) + ':';
                  var m = String('00' + Math.floor(duration % 3600 / 60)).slice(-2) + ':';
                  var s = String('00' + Math.floor(duration % 3600 % 60)).slice(-2);
                  if (h !== '00:') {
                    duration = h + m + s;
                  } else {
                    duration = m + s;
                  }

                  $('span[data-videoid=' + vid + ']').html(duration);

                });
              }
            });

          }
        });

      }
    }

    /**
       * 页面图片懒加载
       * <img src="https://media.kingdomsalvation.org/place_holder/video_lazy.jpg" data-original="http://www.lambsteps-test.com/wp-content/uploads/2017/04/天安門-中共.jpg" width="100%">
       */ }, { key: "lazyLoadImg", value: function lazyLoadImg()
    {
      //  调用图片懒加载
      $('img[data-original]').lazyload({
        effect: "fadeIn" });

    }

    /**
       * 处理组体区域与侧边栏的粘帖效果
       * <div class="row categoryParent">
       *    <div class="col-8">
       *      <main class="js-category-main">
       *      </main>
       *    </div>
       *
       *    <div class="col-4">
       *      <aside class="js-category-aside">   添加notSticky 将取消代码的执行
       *      </aside>
       *    </div>
       * </div>
       */ }, { key: "stickMainWithAside", value: function stickMainWithAside()
    {
      $(document.body).trigger("sticky_kit:recalc");
      $(".js-category-aside").length > 0 && !$(".js-category-aside").hasClass('notSticky') && $(".js-category-aside").stick_in_parent({
        parent: '.categoryParent',
        offset_top: 45 });

    }

    /**
       * 处理移动端 惜朝提出的侧边栏点击箭头展开
       * <div class="card-panel dropmore">
       *    <button class="mobileDropmoreTrigger"></button>
       * <div>
       */ }, { key: "mobileDropmoreTrigger", value: function mobileDropmoreTrigger()
    {
      $(document.body).on('click', '.card-panel.dropmore .mobileDropmoreTrigger', function () {
        $(this).parents('.card-panel').toggleClass('active');
      });
    }

    /**
       * 按钮点赞处理
       *
       * // 文章点赞
       * <button class="v2-like" data-post-id="13817"><i class="icon-favorite"></i>+<span class="like">0</span></button>
       *
       * // 作者点赞
       * <button class="v2-author-like" data-post-id="1"><i class="icon-thumbUp"></i>+<span class="like">444</span></button>
       *
       * window.unLimitLike = true 无限开火权
       */ }, { key: "likeHandler", value: function likeHandler()
    {
      $(document.body).on('click', '.v2-like,.v2-author-like', function () {
        if (!$(this).hasClass('active') && window.v2WebFarm && window.v2WebFarm.ajaxLike || window.unLimitLike === true) {
          var btn = $(this);

          //  多类型点赞判断
          //#############
          var postId;
          var likeType;
          if (btn.hasClass('v2-author-like')) {
            postId = this.dataset.authorId;
            likeType = 'likeAuthor';
          } else if (false) {
            //  继续添加
          } else {
            postId = this.dataset.postId;
            likeType = 'likePost';
          }

          btn.addClass('active');
          var currentCount = btn.find('.like').text();
          ++currentCount;
          btn.find('.like').text(currentCount);

          //  发送ajax 处理点赞
          window.$.ajax({
            data: {
              id: postId,
              type: likeType,
              action: 'like' },

            dataType: 'json',
            type: 'GET',
            url: window.v2WebFarm.ajaxLike }).
          then(function (data) {
            if (data.state) {
              window.$.toast('點贊成功!', 2000, 'rounded');
            }
          });
        }
      });

    }

    //  自动处理页面需要的点赞监听
  }, { key: "pageNeedWatchLike", value: function pageNeedWatchLike() {
      document.querySelector('.v2-like') && this.watchIpLikePost();
      document.querySelector('.v2-author-like') && this.watchIpLikeAuthor();
    }

    // - - - - - - - - - - - - - - - - - - - 点赞监听  这里不能合并到一起,因为页面有不同的数据,就要选用不同的监听 - - - - - - - - - - - - - - - - - - -
    /**
     * 获取当前ip 已点赞的文章按钮
     * 每500ms遍历页面所有的.v2-like 添加已点赞like
     */ }, { key: "watchIpLikePost", value: function watchIpLikePost()
    {
      //  发送ajax 处理点赞
      window.$.ajax({
        data: {
          action: 'getIpLikePosts',
          type: 'likePost' },

        dataType: 'json',
        type: 'GET',
        url: window.v2WebFarm.ajaxLike }).
      then(function (data) {
        if (data.state) {
          //  遍历监听
          window.setInterval(function () {
            var allLikeBtn = (0, _toConsumableArray2["default"])(document.querySelectorAll('.v2-like'));

            //  找到未添加过active的btn
            allLikeBtn.map(function (value) {
              if (value.className.indexOf('active') === -1) {
                var postId = value.dataset.postId;
                if (postId && ~data.data.indexOf(postId)) {
                  value.classList.add('active');
                  var currentCount = parseInt(value.querySelector('.like').innerHTML);
                  ++currentCount;
                  value.querySelector('.like').innerHTML = currentCount;
                }
              }
            });

          }, 500);
        }
      });

    }

    /**
       * 获取当前ip 已点赞作者按钮
       * 每500ms遍历页面所有的.v2-like 添加已点赞like
       */ }, { key: "watchIpLikeAuthor", value: function watchIpLikeAuthor()
    {
      //  发送ajax 处理点赞
      window.$.ajax({
        data: {
          action: 'getIpLikePosts',
          type: 'likeAuthor' },

        dataType: 'json',
        type: 'GET',
        url: window.v2WebFarm.ajaxLike }).
      then(function (data) {
        if (data.state) {
          //  遍历监听
          window.setInterval(function () {
            var allLikeBtn = (0, _toConsumableArray2["default"])(document.querySelectorAll('.v2-author-like'));
            //  找到未添加过active的btn
            allLikeBtn.map(function (value) {
              if (value.className.indexOf('active') === -1) {
                var postId = value.dataset.authorId;
                if (postId && ~data.data.indexOf(postId)) {
                  value.classList.add('active');
                  var currentCount = parseInt(value.querySelector('.like').innerHTML);
                  ++currentCount;
                  value.querySelector('.like').innerHTML = currentCount;
                }
              }
            });

          }, 500);
        }
      });

    } }]);return v2Global;}();



new v2Global();

// - - - - - - - - - - - - - - - - - - - audio 段代码插件 - - - - - - - - - - - - - - - - - - -
var v2AudioShortCode =
function v2AudioShortCode() {(0, _classCallCheck2["default"])(this, v2AudioShortCode);

  // 封装Ajax提交音频时长的函数
  var postid = $('#v2audio').data('pid');
  var ptime = $('#v2audio').data('time');
  function audio_time_ajax(pid, time) {
    $.ajax({
      type: 'post',
      url: ListAjax.ajaxurl,
      dataType: 'json',
      data: {
        security: ListAjax.security,
        postid: pid,
        posttime: time,
        type: 'audio',
        action: 'audio_ajax_callback' },

      success: function success(data) {
        void 0;
      },
      error: function error(data) {
        void 0;
      } });

  }


  $('#v2audio').length > 0 && ~function () {
    var audio = window.v2AudioShortCodeLink;
    var name = window.v2AudioShortCodeName;
    if (audio) {
      $.audio({
        src: audio,
        autoPlay: false,
        frequency: 200 });

      var play = document.getElementById('v2play');
      var mute = document.getElementById('v2mute');
      var duration = document.getElementById('v2duration');
      var currentTime = document.getElementById('v2currentTime');
      var noUiSliderObj = document.getElementById('v2noUiSliderObj');
      play.onclick = function () {
        window.audioMethod.togglePlay();
      };
      window.onaudioPlay = function () {
        play.className = 'icon-pause';
      };
      window.onaudioPause = function () {
        play.className = 'icon-playArrow';
      };
      var noUiSliderMute = document.getElementById('v2noUiSliderMute');
      mute.onclick = function () {
        window.audioMethod.toggleMute();
      };
      window.onaudioMute = function () {
        noUiSliderMute.noUiSlider.set(0);
        mute.className = 'icon-volumeOff';
      };
      window.onaudioUnMute = function (event, value) {
        noUiSliderMute.noUiSlider.set(value * 100);
        mute.className = 'icon-volumeUp';
      };
      var au_time = '';
      window.onaudioLoadEnd = function (ev, audio) {
        au_time = audio.duration.formatTime();
        duration.innerHTML = au_time;
        // 提交音频加载的时间
        if (ptime.trim() == '') {
          audio_time_ajax(postid, au_time);
        }
      };
      window.onaudioWatching = function (ev, data) {
        currentTime.innerHTML = data.currentTime.formatTime();
        noUiSliderObj.noUiSlider.set(data.percentage);
        if (parseInt(data.currentTime) == parseInt(data.duration)) {
          setTimeout(function () {
            currentTime.innerHTML = '00:00';
            play.className = 'icon-playArrow';
          }, 800);
        }
      };

      noUiSlider.create(noUiSliderObj, {
        start: 0,
        connect: [true, false],
        animate: false,
        behaviour: 'snap',
        range: {
          'min': 0,
          'max': 100 } });


      noUiSlider.create(noUiSliderMute, {
        start: 100,
        connect: [true, false],
        animate: false,
        behaviour: 'snap',
        range: {
          'min': 0,
          'max': 100 } });



      noUiSliderObj.noUiSlider.on('start', function (process) {
        window.audioMethod.currentTime(process, true);
        window.audioMethod.pause();
        currentTime.innerHTML = (process[0] / 100 * window.audioMethod.getDuration()).formatTime();
      });
      noUiSliderObj.noUiSlider.on('end', function (process) {
        window.audioMethod.currentTime(process[0], true);
        window.audioMethod.play();
      });
      noUiSliderObj.noUiSlider.on('slide', function (process) {
        window.audioMethod.currentTime(process[0], true);
        currentTime.innerHTML = (process[0] / 100 * window.audioMethod.getDuration()).formatTime();
      });
      noUiSliderMute.noUiSlider.on('slide', function (volume) {
        if (parseInt(volume[0]) == 0) {
          mute.className = 'icon-volumeOff';
        } else {
          mute.className = 'icon-volumeUp';
        }
        window.audioMethod.volume(volume[0], true);
      });
      $('.imageschemameta').prev().before($('.imageschemameta').next().children().eq(0));
      setTimeout(function () {
        $('#v2audio').show();
      }, 100);

      $('#v2js-download').on('click', function () {
        // var link = 'https://tr.kingdomsalvation.org/wp-content/themes/gospel/gajax2/download.php'
        var link = 'https://www.lambsteps.com//wp-content/themes/lambsteps/v2-web-farm/ajax/download/download.php';
        var fileLink = audio;
        var title = name;
        var realLink = link + '?file=' + fileLink + '&title=' + decodeURIComponent(title);
        window.location.href = realLink;
      });

    }

  }();
};


new v2AudioShortCode();


// - - - - - - - - - - - - - - - - - - - 个人类库 V2B (B关键字会冲突) - - - - - - - - - - - - - - - - - - -
var V2BClass = /*#__PURE__*/function () {function V2BClass() {(0, _classCallCheck2["default"])(this, V2BClass);}(0, _createClass2["default"])(V2BClass, [{ key: "renderImgTag",

    /**
                                                                                                                                                                                 * 渲染一张图片
                                                                                                                                                                                 * @param url
                                                                                                                                                                                 * @returns {Promise}
                                                                                                                                                                                 */value: function renderImgTag(
    url) {
      return new Promise(function (res, rej) {
        if (url) {
          var img = new Image();

          img.onload = function () {
            res(img);
          };

          img.onerror = function () {
            rej(new Error("Could not load image at ".concat(url)));
          };

          img.src = url;
        }
      });
    } }]);return V2BClass;}();



window.V2B = new V2BClass();

// - - - - - - - - - - - - - - - - - - - 头部 - - - - - - - - - - - - - - - - - - -
var v2Header = /*#__PURE__*/function () {
  function v2Header() {(0, _classCallCheck2["default"])(this, v2Header);
    this.$menu = $('#nav-menu');
    //  调用插件
    this.pluginsCall();

    //  克隆2个menu
    $('#nav-menu-mobile').length > 0 && this.cloneMenu();
    //  克隆 assist
    this.cloneAssist();

    //  如果是子分类找到父分类添加active
    this.$menu.find('ul li.active').parents('li').eq(0).addClass('active');
    //  处理文章页面目录定位
    if ($('.bread').length > 0 && $('.bread').children('span').eq(1).find('a').length > 0) {
      var src = $('.bread').children('span').eq(1).find('a').attr('href');
      if (src == "https://www.lambsteps.com/category/thorough") {
        src = "https://www.lambsteps.com/gospel-vedio";
      }
      $('#nav-menu a').map(function () {
        if ($(this).attr('href') == src) {
          $(this).parent().addClass('active');
        }
      });
    }

    //  添加velocity 将当前选中滚到最前
    $('#nav-menu-mobile .pcUnScroll').children('.active').velocity('scroll', {
      axis: "x",
      container: $('#nav-menu-mobile .pcUnScroll') });

  }

  //  克隆 assist
  (0, _createClass2["default"])(v2Header, [{ key: "cloneAssist", value: function cloneAssist() {
      var oPcAssist = $('#v2-navbar .assist');
      var oMobileAssist = $('#v2-mobile-side-nav .assist');

      oPcAssist.children().map(function () {
        oMobileAssist.append($(this).clone());
      });

    }

    /**
       * 克隆移动端和移动端navbar的菜单
       */ }, { key: "cloneMenu", value: function cloneMenu()
    {
      var navMenuMobile = $('#nav-menu-mobile');

      //  克隆移动端
      var mobileMenu = navMenuMobile.children('.pcUnScroll');
      this.$menu.children('li').map(function () {
        var itemClone = $(this).clone();
        itemClone.children('ul').remove();
        mobileMenu.append(itemClone);
      });

      //  移动端navbar的菜单
      var navBarMobile = $('#v2-mobile-side-nav .menu');
      var cloneMenu = this.$menu.clone();
      cloneMenu.get(0).className = '';
      cloneMenu.get(0).id = '';
      navBarMobile.append(cloneMenu);
    } }, { key: "pluginsCall", value: function pluginsCall()

    {
      //  调用移动端的侧边栏插件
      $('.js-mobile-nav-bar-trigger').sideNav({
        menuWidth: 392,
        edge: 'right',
        zIndex: 997 });

      $(window).resize(function () {
        if (window.innerWidth > 1216) {
          $('.js-mobile-nav-bar-trigger').sideNav('hide');
        }
      });

      //  导航浮动插件调用
      var oStickNav = $('#primary-nav-box');
      var iTop = $('#banner').outerHeight() || 360;
      oStickNav.css('top', iTop);

      oStickNav.stick_in_parent({
        parent: document.documentElement }).

      on('sticky_kit:stick', function (e) {
        // 触发
      }).
      on('sticky_kit:unstick', function () {
        //  关闭
      });

    } }]);return v2Header;}();


new v2Header();

// - - - - - - - - - - - - - - - - - - - 页脚 - - - - - - - - - - - - - - - - - - -
var v2Footer = /*#__PURE__*/function () {
  function v2Footer() {(0, _classCallCheck2["default"])(this, v2Footer);
    //  复制导航上的menu
    this.copyMenu();

    var that = this;
    //  处理页脚上的menu排版
    if (window.innerWidth > 980) {
      this.sortMenu();
    }
    $(window).resize(function () {
      if (window.innerWidth > 980) {
        that.sortMenu();
      }
      $('#v2-footer .menuBox .card').css('visibility', 'visible');
    });

    //  copy移动端页脚上的menu
    this.copyMobileMenu();

    //  加入下拉动画
    // this.showAnimate()

    $('#backTop').length > 0 && this.backTopHandler();
  }

  //  返回向上按钮处理
  (0, _createClass2["default"])(v2Footer, [{ key: "backTopHandler", value: function backTopHandler() {var _this = this;
      this.backTop = $('#backTop');
      this.footerTop = $('#v2-footer').position().top;
      this.windowHeight = window.innerHeight;
      this.stickyKitHeight = this.windowHeight * 1.2;

      //  拖拽窗口重置数值
      $(window).resize(function (ev) {
        _this.footerTop = $('#v2-footer').position().top;
        _this.windowHeight = window.innerHeight;
        _this.stickyKitHeight = _this.windowHeight * 1.2;
        _this._changeBackTopButtomPosition();
      }).trigger('resize');

      //  循环执行绑定
      window.setInterval(function () {
        _this.footerTop = $('#v2-footer').position().top;
        _this.windowHeight = window.innerHeight;
        _this.stickyKitHeight = _this.windowHeight * 1.2;
        _this._changeBackTopButtomPosition();
      }, 500);

      $(window).on('scroll', function (ev) {
        _this._changeBackTopButtomPosition();
      }).trigger('scroll');

      //  点击返回顶部
      $(this.backTop).click(function (ev) {
        $(document.body).velocity('scroll');
      });

    } }, { key: "_changeBackTopButtomPosition", value: function _changeBackTopButtomPosition()

    {
      //  计算已经滚动高度
      var scrollTop = $(window).scrollTop();

      if (scrollTop > this.stickyKitHeight) {
        //  处理横在footer上
        if (!this.backTop.hasClass('show')) {
          this.backTop.addClass('show');
          this.backTop.css('opacity', 0).velocity('stop');
          this.backTop.velocity('transition.bounceUpIn');
        }

        var bottom = 44;
        if (scrollTop + this.windowHeight > this.footerTop) {
          bottom = scrollTop + this.windowHeight - this.footerTop + 16;
        }
        this.backTop.css('bottom', bottom);

      } else {
        if (this.backTop.hasClass('show')) {
          this.backTop.stop(true, false).fadeOut();
          this.backTop.removeClass('show');
        }
      }
    }

    /**
       * copy移动端页脚上的menu
       */ }, { key: "copyMobileMenu", value: function copyMobileMenu()
    {
      var aItem = $('#v2-footer .menuBox .item');
      var oTarget = $('#v2-footer .menuBoxM');

      aItem.map(function (index, value) {
        var oAClone = $(value).children('h3').children('a').clone();
        oTarget.append(oAClone, "<span class=\"line\"></span>");
      });

    }

    /**
       * 显示PC的下来加载动画
       */ }, { key: "showAnimate", value: function showAnimate()
    {
      V2CardPanelSr.reveal(document.getElementById('v2-footer'));
    }

    //  处理页脚上的menu排版
  }, { key: "sortMenu", value: function sortMenu() {
      var oMenuBox = $('#v2-footer .menuBox');

      //  判断不被多次刷新
      if (oMenuBox.children('.item').length == 0) {
        return false;
      }

      //  创建6个盒子塞进去
      var carArr = [];
      //  设置menuBox 一行显示几个
      var count = 6;
      for (var i = 0; i < count; i++) {
        carArr.push($("<div class=\"card\"></div>"));
      }

      //  将导航塞进去
      oMenuBox.children().map(function (index, value) {
        var cardHeightArr = [];
        //  获取每个card的高度
        carArr.map(function (v) {
          var outerHeight = v.oldOuterHeight ? v.oldOuterHeight : 0;
          cardHeightArr.push(outerHeight);
        });
        var minHeight = Math.min.apply(Math, cardHeightArr);

        var cardIndex = cardHeightArr.indexOf(minHeight);

        carArr[cardIndex].append($(value).clone());
        carArr[cardIndex].oldOuterHeight = carArr[cardIndex].oldOuterHeight ? carArr[cardIndex].oldOuterHeight : 0;
        carArr[cardIndex].oldOuterHeight += $(value).outerHeight();
      });

      oMenuBox.children().remove();
      oMenuBox.append(carArr);
    }

    /**
       * 复制导航上的menu
       */ }, { key: "copyMenu", value: function copyMenu()
    {
      var oNavMenu = $('#nav-menu');
      var oItem = $('<div class="item" />');
      var oTarget = $('#v2-footer .menuBox');

      /*
                                              <div class="item">
                                                  <h3><a href="#">认识主耶稣</a></h3>
                                                  <a href="#">主耶稣是谁</a>
                                                  <a href="#">主耶稣生平</a>
                                                  <a href="#">耶稣的救恩</a>
                                              </div>
                                              */

      oNavMenu.children().map(function (index, value) {
        var oH3Link = $(value).children('a').attr('href');
        var oH3Title = $(value).children('a').text();
        var html = "<h3><a href=\"".concat(oH3Link, "\">").concat(oH3Title, "</a></h3>");

        //  遍历子节点
        if ($(value).children('ul').length > 0) {
          $(value).children('ul').children().map(function (k, v) {
            var oALink = $(v).children('a').attr('href');
            var oATitle = $(v).children('a').text();
            html += "<a href=\"".concat(oALink, "\">").concat(oATitle, "</a>");
          });
        }

        var oCloneItem = oItem.clone();
        oCloneItem.append(html);
        oTarget.append(oCloneItem);
      });


    } }]);return v2Footer;}();



new v2Footer();

},{"@babel/runtime/helpers/classCallCheck":4,"@babel/runtime/helpers/createClass":5,"@babel/runtime/helpers/interopRequireDefault":6,"@babel/runtime/helpers/toConsumableArray":9}],2:[function(require,module,exports){
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
},{}],3:[function(require,module,exports){
var arrayLikeToArray = require("./arrayLikeToArray");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
},{"./arrayLikeToArray":2}],4:[function(require,module,exports){
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
},{}],5:[function(require,module,exports){
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
},{}],6:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
},{}],7:[function(require,module,exports){
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;
},{}],8:[function(require,module,exports){
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
},{}],9:[function(require,module,exports){
var arrayWithoutHoles = require("./arrayWithoutHoles");

var iterableToArray = require("./iterableToArray");

var unsupportedIterableToArray = require("./unsupportedIterableToArray");

var nonIterableSpread = require("./nonIterableSpread");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
},{"./arrayWithoutHoles":3,"./iterableToArray":7,"./nonIterableSpread":8,"./unsupportedIterableToArray":10}],10:[function(require,module,exports){
var arrayLikeToArray = require("./arrayLikeToArray");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
},{"./arrayLikeToArray":2}]},{},[1])

//# sourceMappingURL=global.js.map
